import { Grid, IconButton, Tooltip } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import EditIcon from '@mui/icons-material/Edit';
import { SarlaftListActionsProps } from './props';
import { SARLAFT_EDIT } from '../../../../../../routes/paths';
import { MouseEventHandler } from 'react';

export const SarlaftListActions = ({ id }: SarlaftListActionsProps) => {
    const navigate = useNavigate();
    const handleEdit: MouseEventHandler<HTMLButtonElement> | undefined = (
        e
    ) => {
        e.stopPropagation();
        navigate(`${SARLAFT_EDIT}/${id}/#CHANGE_STATUS`);
    };

    return (
        <Grid textAlign="left" width="100%">
            <Tooltip title="Editar">
                <IconButton size="small" onClick={handleEdit}>
                    <EditIcon type="submit" sx={{ color: 'primary.main' }} />
                </IconButton>
            </Tooltip>
        </Grid>
    );
};
